export default __webpack_public_path__ + "static/media/classify-joel.dd7696c6.jpg";